var check = function check() {
  var blocks = document.querySelectorAll('.club101__block:not(.club101__block--active)');
  if (blocks.length) {
    var winHeight = window.innerHeight;
    for (var i = 0; i < blocks.length; i += 1) {
      var block = blocks[i];
      var y = block.getBoundingClientRect().top - winHeight;
      if (y < 0) {
        block.classList.add('club101__block--active');
      }
    }
    requestAnimationFrame(check);
  }
}();
